import {
    REGISTER_DRIVER_REQUEST,
    REGISTER_DRIVER_SUCCESS,
    REGISTER_DRIVER_FAILURE,
    FETCH_MY_DRIVER_PARTNER_REQUEST,
    FETCH_MY_DRIVER_PARTNER_SUCCESS,
    FETCH_MY_DRIVER_PARTNER_FAILURE,
    REGISTER_DRIVER_PARTNER_REQUEST,
    REGISTER_DRIVER_PARTNER_SUCCESS,
    REGISTER_DRIVER_PARTNER_FAILURE,
    UPDATE_DRIVER_PARTNER_REQUEST,
    UPDATE_DRIVER_PARTNER_SUCCESS,
    UPDATE_DRIVER_PARTNER_FAILURE,
    FETCH_REFERRED_DRIVERS_REQUEST,
    FETCH_REFERRED_DRIVERS_SUCCESS,
    FETCH_REFERRED_DRIVERS_FAILURE,
    FETCH_REFERRAL_MILESTONES_REQUEST,
    FETCH_REFERRAL_MILESTONES_SUCCESS,
    FETCH_REFERRAL_MILESTONES_FAILURE,
    FETCH_PARTNER_PAYOUTS_REQUEST,
    FETCH_PARTNER_PAYOUTS_SUCCESS,
    FETCH_PARTNER_PAYOUTS_FAILURE,
    FETCH_PENDING_COMMISSIONS_REQUEST,
    FETCH_PENDING_COMMISSIONS_SUCCESS,
    FETCH_PENDING_COMMISSIONS_FAILURE,
} from "./types";

import {
    getMyDriverPartner,
    registerDriverPartner,
    registerDriver,
    updateDriverPartner,
    fetchReferralMilestones,
    fetchReferredDrivers,
    fetchPendingCommissions,
} from "../../services/driverPartnerService";
import {
    fetchPartnerPayouts,
} from "../../services/driverPartnerPayoutService";


export const registerDriverAction =
    (payload) =>
    async (dispatch) => {
        dispatch({
            type: REGISTER_DRIVER_REQUEST,
        });

        const result =
            await registerDriver(payload);

        if (result.success) {
            dispatch({
                type: REGISTER_DRIVER_SUCCESS,
                payload: result.data,
            });
        } else {
            dispatch({
                type: REGISTER_DRIVER_FAILURE,
                payload: result.error,
            });
        }

        return result;
    };

export const fetchMyDriverPartnerAction =
    () =>
    async (
        dispatch
    ) => {
        dispatch({
            type: FETCH_MY_DRIVER_PARTNER_REQUEST,
        });

        const result =
            await getMyDriverPartner();

        if (
            result.success
        ) {
            dispatch({
                type: FETCH_MY_DRIVER_PARTNER_SUCCESS,
                payload:
                    result.data,
            });
        } else {
            dispatch({
                type: FETCH_MY_DRIVER_PARTNER_FAILURE,
                payload:
                    result.error,
            });
        }

        return result;
    };

export const registerDriverPartnerAction =
    (
        payload
    ) =>
    async (
        dispatch
    ) => {
        dispatch({
            type: REGISTER_DRIVER_PARTNER_REQUEST,
        });

        const result =
            await registerDriverPartner(
                payload
            );

        if (
            result.success
        ) {
            dispatch({
                type: REGISTER_DRIVER_PARTNER_SUCCESS,
                payload:
                    result.data,
            });
        } else {
            dispatch({
                type: REGISTER_DRIVER_PARTNER_FAILURE,
                payload:
                    result.error,
            });
        }

        return result;
    };

export const updateDriverPartnerAction =
    (
        driverPartnerId,
        data
    ) =>
    async (
        dispatch
    ) => {
        dispatch({
            type:
                UPDATE_DRIVER_PARTNER_REQUEST,
        });

        const result =
            await updateDriverPartner(
                driverPartnerId,
                data
            );

        if (
            result.success
        ) {
            dispatch({
                type:
                    UPDATE_DRIVER_PARTNER_SUCCESS,
                payload:
                    result.data,
            });
        } else {
            dispatch({
                type:
                    UPDATE_DRIVER_PARTNER_FAILURE,
                payload:
                    result.error,
            });
        }

        return result;
    };

export const fetchReferredDriversAction =
    (
        page = 1,
        size = 10
    ) =>
    async (
        dispatch
    ) => {
        dispatch({
            type:
                FETCH_REFERRED_DRIVERS_REQUEST,
        });

        const result =
            await fetchReferredDrivers(
                page,
                size
            );

        if (
            result.success
        ) {
            dispatch({
                type:
                    FETCH_REFERRED_DRIVERS_SUCCESS,
                payload:
                    result.data,
            });
        } else {
            dispatch({
                type:
                    FETCH_REFERRED_DRIVERS_FAILURE,
                payload:
                    result.error,
            });
        }

        return result;
    };

export const fetchReferralMilestonesAction =
    () =>
    async (
        dispatch
    ) => {
        dispatch({
            type:
                FETCH_REFERRAL_MILESTONES_REQUEST,
        });

        const result =
            await fetchReferralMilestones();

        if (
            result.success
        ) {
            dispatch({
                type:
                    FETCH_REFERRAL_MILESTONES_SUCCESS,
                payload:
                    result.data,
            });
        } else {
            dispatch({
                type:
                    FETCH_REFERRAL_MILESTONES_FAILURE,
                payload:
                    result.error,
            });
        }

        return result;
    };

export const fetchPartnerPayoutsAction =
    (
        partnerId,
        page = 1,
        size = 10
    ) =>
    async (
        dispatch
    ) => {
        dispatch({
            type:
                FETCH_PARTNER_PAYOUTS_REQUEST,
        });

        const result =
            await fetchPartnerPayouts(
                partnerId,
                page,
                size
            );

        if (
            result.success
        ) {
            dispatch({
                type:
                    FETCH_PARTNER_PAYOUTS_SUCCESS,
                payload:
                    result.data,
            });
        } else {
            dispatch({
                type:
                    FETCH_PARTNER_PAYOUTS_FAILURE,
                payload:
                    result.error,
            });
        }

        return result;
    };

export const fetchPendingCommissionsAction =
    (
        page = 1,
        size = 10
    ) =>
    async (
        dispatch
    ) => {
        dispatch({
            type:
                FETCH_PENDING_COMMISSIONS_REQUEST,
        });

        const result =
            await fetchPendingCommissions(
                page,
                size
            );

        if (
            result.success
        ) {
            dispatch({
                type:
                    FETCH_PENDING_COMMISSIONS_SUCCESS,
                payload:
                    result.data,
            });
        } else {
            dispatch({
                type:
                    FETCH_PENDING_COMMISSIONS_FAILURE,
                payload:
                    result.error,
            });
        }

        return result;
    };